import { devtools } from 'zustand/middleware'
import { create } from 'zustand'
import { pick } from 'lodash'
import { IToastStore, IToastState } from './type'
import { StoreGet, StoreSet } from '@/types'
import { composeMiddleware } from '../middleware'
import { ToastType } from 'task-eva-ui'

const initialState = (): IToastState => ({
  show: false,
  type: ToastType.success,
  content: undefined,
  top: '10vh',
  duration: 1500,
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const actions = (set: StoreSet<IToastStore>, get: StoreGet<IToastStore>) => ({
  showGlobalToast: (props: IToastState) => {
    set(() => ({
      ...props,
      show: true,
    }))
  },
  updateGlobalToast: (params: IToastState) => {
    set(() => ({
      duration: 1500,
      ...params,
    }))
  },
})

const getters = (get: StoreGet<IToastStore>) => ({
  getToastProps: () => pick(get(), Reflect.ownKeys(initialState())),
})

export const useToastStore = create<IToastStore>()(
  composeMiddleware([devtools], (set: StoreSet<IToastStore>, get: StoreGet<IToastStore>) => ({
    ...initialState(),
    ...actions(set, get),
    ...getters(get),
  })),
)
